import React, { forwardRef } from 'react';
import styles from './styleConstants.module.css';

const cx = (...classes: (string | undefined)[]) =>
  classes.filter(Boolean).join(' ');

type H2Props = React.ComponentPropsWithoutRef<'h2'>;
type H2LargeProps = React.ComponentPropsWithoutRef<'h2'> & { color?: string };
type H3Props = React.ComponentPropsWithoutRef<'h3'>;
type PProps = React.ComponentPropsWithoutRef<'p'>;

export const H2 = forwardRef<HTMLHeadingElement, H2Props>(
  ({ className, ...rest }, ref) => (
    <h2 ref={ref} className={cx(styles.h2, className)} {...rest} />
  ),
);
H2.displayName = 'H2';

export const H2Large = forwardRef<HTMLHeadingElement, H2LargeProps>(
  ({ className, color, style, ...rest }, ref) => (
    <h2
      ref={ref}
      className={cx(styles.h2Large, className)}
      style={color ? { color, ...style } : style}
      {...rest}
    />
  ),
);
H2Large.displayName = 'H2Large';

export const H3 = forwardRef<HTMLHeadingElement, H3Props>(
  ({ className, ...rest }, ref) => (
    <h3 ref={ref} className={cx(styles.h3, className)} {...rest} />
  ),
);
H3.displayName = 'H3';

export const P = forwardRef<HTMLParagraphElement, PProps>(
  ({ className, ...rest }, ref) => (
    <p ref={ref} className={cx(styles.p, className)} {...rest} />
  ),
);
P.displayName = 'P';
